import { ReadyRoomShell } from "@/components/vyllage/ReadyRoomShell";

export function AvatarPage() {
  return <ReadyRoomShell panel="avatar" />;
}
